import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#697077",
      d: "M8.333 3.333V7.5c0 .46-.373.833-.833.833H3.333v3.333H7.5c.46 0 .833.373.833.833v4.167h3.333V12.5a.833.833 0 0 1 .833-.833h4.167V8.333H12.5a.833.833 0 0 1-.833-.833V3.333H8.333zm5 3.333h3.333c.92 0 1.667.746 1.667 1.667v3.333c0 .92-.746 1.667-1.667 1.667h-3.333v3.333c0 .92-.746 1.667-1.667 1.667H8.333c-.92 0-1.667-.746-1.667-1.667v-3.333H3.333c-.92 0-1.667-.746-1.667-1.667V8.333c0-.92.746-1.667 1.667-1.667h3.333V3.333c0-.92.746-1.667 1.667-1.667h3.333c.92 0 1.667.746 1.667 1.667v3.333z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "first-aid"}) } }